<template>
  <v-card height="570px" class="d-flex flex-column overflow-hidden">
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="5">
          <v-select
            v-model="item_select"
            :items="['Присутствует', 'Отсутствует']"
            label="Отличительный признак"
            hide-details
            clearable
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="ml-2 d-flex align-center">
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog = !dialog"
                small
                color="teal darken-1"
                v-bind="attrs"
                v-on="on"
                outlined
                rounded
              >
                Дополнить список
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Добавление заявления</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="search_form_name"
                        label="Имя"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        label="Фамилия"
                        v-model="search_form_surname"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-model="search_form_patronymic"
                        label="Отчество"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <div>
                  {{ get_stm_hostel }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="getStmHostel()"
                  small
                  color="teal darken-1"
                  dark
                  rounded
                >
                  Добавить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-spacer/>
        <div class="d-flex align-end">
          <span>Всего заявлений:</span>
          <span class="ml-1 font-weight-bold ">{{count_statements }}</span>
        </div>
      </v-row>
    </v-card-text>

    <v-divider/>

    <v-data-table
      :headers="headers_table_state"
      :items="filteredItems"
      :search="search_table"
      :items-per-page="5"
      :page.sync="page"
      @page-count="pageCount = $event"
      no-data-text="Данные отсутствуют"
      no-results-text="Совпадений не найдено"
      item-key="person.full_name"
      hide-default-footer
      :loading="status_statements"
      loading-text="Загрузка заявлений... пожалуйста подождите"
      mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col class="d-flex align-end">
              <v-switch
                v-model="recommendation"
                class="ma-0"
                inset
                label="Рекомендуемые"
                dense
                hide-details
              ></v-switch>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6">
              <v-text-field
                v-model="search_table"
                label="Поиск"
                dense
                outlined
                hide-details
              >
                <template v-slot:append>
                  <v-icon size="20px">
                    fa-search
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          x-small
          icon
          :disabled="!active_place_hostel.name_hostel"
          @click="successStatement(item)"
        >
          <v-icon
            color="success"
            size="25px"

          >
            fa-check
          </v-icon>
        </v-btn>
        <v-btn
          x-small
          @click="openDrawer(item)"
          icon
        >
          <v-icon
            size="15px"
          >
            fa-ellipsis-v
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.statement_hostel.commission.dean_ex_work_confirm="{ item }">
        <v-chip
          small
          rounded
          elevation="0"
          :color="setStatus(item.statement_hostel.commission.dean_ex_work_confirm)"
          outlined
        >
          {{ setStatus(item.statement_hostel.commission.dean_ex_work_confirm) === 'green' ? 'Одобрено':
          'Рассматривается'}}
        </v-chip>
      </template>
      <template v-slot:item.statement_hostel.privilege="{ item }">
        <v-icon
          v-if="item.statement_hostel.privilege === 'Отсутствует'"
          size="20px"
        >
          fa-universal-access
        </v-icon>
        <v-icon
          v-else
          size="20px"
          color="green"
        >
          fa-universal-access
        </v-icon>
      </template>
      <template v-slot:item.statement_hostel.id="{ item }">
        <v-chip class="px-4 py-1">
          <v-icon size="12px" left>
            fa-trophy
          </v-icon>
          {{ filteredItems.indexOf(item) + 1}}
        </v-chip>
      </template>
    </v-data-table>
    <v-spacer/>
    <v-card-actions>
      <v-pagination
        class="mx-auto"
        v-model="page"
        total-visible="8"
        :length="pageCount"
        color="teal"
        circle
      ></v-pagination>
    </v-card-actions>
    <v-navigation-drawer
      class="rounded-xl rounded-tr-0"
      width="400px"
      v-model="drawer"
      right
      touchless
      absolute
      temporary
    >

    </v-navigation-drawer>
  </v-card>
</template>

<script>
    import {mapState, mapActions, mapMutations, mapGetters} from "vuex";
    import _ from "lodash";

    export default {
        name: 'CardListStatements',
        props: {
            active_place_hostel:{
                type: Object
            }
        },
        data: () => ({
            page: 1,
            pageCount: 0,
            dialog: false,
            drawer: false,
            curr_state: {},
            curr_place: [],
            item_select: '',
            search_table: null,
            recommendation: false,
            headers_table_state: [
                {text: 'МЕСТО', value: 'statement_hostel.id', sortable: false, align: 'center'},
                {text: 'ФИО', value: 'person.full_name', sortable: false},
                {text: 'РАУ', value: 'statement_hostel.rating', sortable: false, align: 'center'},
                {text: 'ПРИЗНАК', value: 'person.privilege', sortable: false, align: 'center'},
                {text: 'СТАТУС', value: 'statement_hostel.commissions.dean_ex_work_confirm', sortable: false, align: 'center'},
                {text: 'ТИП', value: 'statement_hostel.statement_type_name', sortable: false, align: 'center'},
                {text: 'ДАТА ОТПРАВЛЕНИЯ', value: 'created_at', sortable: false, align: 'center'},
                {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: 'center'},
            ],
        }),
        mounted() {

        },
        computed: {
            ...mapState({
                status_statements: state => state.interactionStatement.status_statements,
                result_data_statements: state => state.interactionStatement.result_data_statements,
                get_stm_hostel: state => state.interactionStatement.get_stm_hostel,
                count_statements: state => state.interactionStatement.count_statements,
                list_statements: state => state.interactionStatement.list_statements,
            }),
            ...mapGetters({

            }),
            filteredItems() {
                if (this.recommendation === true) return _.orderBy(this.setRecommendation,
                    ['person.privilege', 'statement_hostel.rating'],
                    ['asc', 'desc']).filter((state) => state.commission?.dean_ex_work_confirm === 1)
                else if (!this.item_select) {
                    return _.orderBy(this.list_statements.statement_hostels,
                        ['person.privilege', 'statement_hostel.rating'],
                        ['asc', 'desc']).filter((state) => state.statement_hostel.commission?.dean_ex_work_confirm === 1)
                } else {
                    const hasAttribute = this.item_select === "Присутствует"
                    return this.list_statements.statement_hostels.filter((item) =>
                        hasAttribute ? item.person?.privilege !== "Отсутствует" && item.statement_hostel.commission?.dean_ex_work_confirm === 1 : item.person?.privilege === "Отсутствует" && item.statement_hostel.commission?.dean_ex_work_confirm === 1
                    )
                }
            },
            setRecommendation() {
                let ms_rec = []
                let recommendation = {}
                if (this.active_place_hostel.name_room && this.recommendation === true) {
                    this.list_statements.statement_hostels.forEach(state => {
                        if (state.dean_ex_work_confirm === 1) {
                            state.place_hostel.forEach(place => {
                                if (place.name_hostel === this.active_place_hostel.name_hostel &&
                                    place.name_section === this.active_place_hostel.name_section &&
                                    place.name_room === this.active_place_hostel.name_room) {
                                    recommendation = state
                                }
                            })
                            if (Object.keys(recommendation).length !== 0) ms_rec.push(recommendation)
                            recommendation = {}
                        }
                    })
                    return ms_rec
                }
            },
            search_form_name: {
                get () {
                    return this.$store.state.interactionStatement.search_stm_hostel.name
                },
                set (value) {
                    this.$store.commit('interactionStatement/setFormName', value)
                }
            },
            search_form_surname: {
                get () {
                    return this.$store.state.interactionStatement.search_stm_hostel.surname
                },
                set (value) {
                    this.$store.commit('interactionStatement/setFormSurname', value)
                }
            },
            search_form_patronymic: {
                get () {
                    return this.$store.state.interactionStatement.search_stm_hostel.patronymic
                },
                set (value) {
                    this.$store.commit('interactionStatement/setFormPatronymic', value)
                }
            },
        },
        watch: {},
        methods: {
            ...mapMutations({
                pushResDataStates: 'interactionStatement/pushResDataStates',
                pushDopStatement: 'interactionStatement/pushDopStatement',
            }),
            ...mapActions({
                GetStmHostel: 'interactionStatement/GetStmHostel',
            }),
            async getStmHostel(){
                await this.GetStmHostel()
                this.pushDopStatement()
            },
            successStatement(stm_hostel) {
                const length = this.result_data_statements.data_statement.length

                let room_info = this.active_place_hostel.room_info
                let count_check_places = room_info.total - room_info.occupied
                if (length < count_check_places) {
                    if (!this.result_data_statements.data_statement.includes(stm_hostel)) this.pushResDataStates(stm_hostel)
                }
            },
            openDrawer(item) {
                this.curr_state = item
                this.curr_place = this.curr_state
                this.drawer = !this.drawer
            },
            setStatus(conf) {
                if (conf === 1) {
                    return 'orange'
                } else if (conf === 2) {
                    return 'green'
                }
            },

        }
    }
</script>

<style scoped>
</style>